import { Component, ErrorInfo, ReactNode } from 'react';
import { miniApp } from '@telegram-apps/sdk-react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught error:', error, errorInfo);
  }

  handleReload = () => {
    // Try to close and reopen the app
    try {
      miniApp.close();
    } catch {
      // Fallback: just reload the page
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-full flex-col items-center justify-center gap-6 p-6 text-center">
          <div className="text-6xl">😵</div>
          <h1 className="text-xl font-bold text-white">Something went wrong</h1>
          <p className="text-gray-400">
            {this.state.error?.message || 'An unexpected error occurred'}
          </p>
          <button
            onClick={this.handleReload}
            className="rounded-xl bg-primary-500 px-6 py-3 font-semibold text-white transition-colors hover:bg-primary-600 active:bg-primary-700"
          >
            Reload App
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
